/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './receiptInfo.tpl.html';

angular
  .module('shared.receiptInfo', [])
  /**
   * Controller for the receiptInfo template.
   */
  .controller('ReceiptInfoCtrl', function ($scope, httpBilling) {
    $scope.showInfoPopup = false;
    // value used to track local value of extra info.
    // Note that the extraInfoOrig value is bound in the directive.
    $scope.extraInfo = angular.copy($scope.extraInfoOrig);

    /**
     * Handler for the Done button.
     */
    $scope.doDone = function () {
      var handleResp = function () {
        // Reset the base value.
        $scope.extraInfoOrig = angular.copy($scope.extraInfo);
        // Set the current values to pristine and close
        $scope.extraInfoForm.$setPristine();
        $scope.showInfoPopup = false;
      };
      if (_.isEmpty($scope.extraInfo.receiptInfo)) {
        httpBilling.deleteExtraInfo().then(handleResp);
      } else {
        httpBilling
          .updateExtraInfo($scope.extraInfo.receiptInfo)
          .then(handleResp)
          // Call the update function.
          .then($scope.update);
      }
    };

    /**
     * Handler for the cancel button.
     */
    $scope.doCancel = function () {
      $scope.extraInfo = angular.copy($scope.extraInfoOrig);
      $scope.showInfoPopup = false;
    };

    // Watch the local receiptInfo value and set the form to pristine
    // if the value returns to the original state.
    $scope.$watch('extraInfo.receiptInfo', function (newValue) {
      if (angular.equals(newValue, $scope.extraInfoOrig.receiptInfo)) {
        $scope.extraInfoForm.$setPristine();
      }
    });

    $scope.showAddInfoText = function () {
      return $scope.extraInfo.receiptInfo === null || $scope.extraInfo.receiptInfo === '';
    };
  })
  /**
   * The directive for the receipt info view.
   */
  .directive('receiptInfo', function () {
    return {
      templateUrl: 'shared/receiptInfo/receiptInfo.tpl.html',
      scope: {
        extraInfoOrig: '=info',
        // method binding to update attribute
        update: '&'
      },
      controller: 'ReceiptInfoCtrl'
    };
  });
